import {Button, Form, FormItem, InputAmount} from 'common/components'
import {formatMoney} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {useUpdateDrawdown, DrawdownItem} from '..'

interface DrawdownAmountFormProps {
  projectUuid: string
  drawdown: DrawdownItem
  onClose: () => void
}

export default function DrawdownAmountForm({
  projectUuid,
  drawdown,
  onClose,
}: DrawdownAmountFormProps) {
  const {mutate: updateDrawdown, isMutating} = useUpdateDrawdown(
    projectUuid,
    drawdown.uuid,
    onClose
  )

  const handleFinish = (values: any) => {
    updateDrawdown(values)
  }

  const initialValues = {
    approvedAmount: drawdown.approvedAmount || drawdown.requestedAmount,
  }

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <FormItem
        name="approvedAmount"
        label={`Approved amount (requested ${formatMoney(
          drawdown.requestedAmount
        )})`}
        rules={FIELD_RULES}
      >
        <InputAmount autoFocus />
      </FormItem>
      <Button block htmlType="submit" loading={isMutating}>
        Save
      </Button>
    </Form>
  )
}
